import { Component, Input } from '@angular/core';

import { AbstractDialogComponent } from '@Core/Dialogs/components/AbstractDialog/abstract-dialog.component';
import { CoreDialogService } from '@Core/Dialogs/services/dialog.service';
import { messageSeverityEnum } from '../../../../Common/Misc/enums/message-severity.enum';
import { ButtonTypesEnum } from '../../../../Common/Forms/enums/button-types.enum';

@Component({
    selector: 'agpr-generating-analysis-dialog',
    templateUrl: './generating-analysis-dialog.component.html',
    styleUrls: ['./generating-analysis-dialog.component.scss'],
    standalone: false
})
export class GeneratingAnalysisDialogComponent extends AbstractDialogComponent {
    readonly messageSeverityEnum = messageSeverityEnum;
    readonly buttonTypesEnum = ButtonTypesEnum;
    id: string = 'generatingAnalysisDialog';
    constructor(
        public coreDialogService: CoreDialogService,
    ) {
        super(coreDialogService, 'GeneratingAnalysisDialog');
    }

    cancel() {
        this.closeDialog(true);
    }
}
